<div class="data-extraction">
    <h1 class="data-extraction__header">
        {{'dataExtractionRquest.dataExtractionOverview'|cxTranslate}}
    </h1>

    <div class="data-extraction__content">
        <form [formGroup]="dataExtractionOverviewForm">
            <p>
                {{'dataExtractionOverviewPage.p1'|cxTranslate}}
            </p>

            <p class="data-extraction__note">
                <strong>{{'dataExtractionOverviewPage.Note'|cxTranslate}}</strong>
            </p>

            <p>
                {{'dataExtractionOverviewPage.p2'|cxTranslate}}
            </p>

            <div class="data-extraction__address">
                {{'dataExtractionOverviewPage.address1'|cxTranslate}}<br>
                {{'dataExtractionOverviewPage.address2'|cxTranslate}}<br>
                {{'dataExtractionOverviewPage.address3'|cxTranslate}}<br>
                {{'dataExtractionOverviewPage.address4'|cxTranslate}}
            </div>

            <p>
                <br>
                {{'dataExtractionOverviewPage.p3_1'|cxTranslate}}&nbsp;<a
                    href="mailto:dataextraction@bendix.com">dataextraction&#64;bendix.com</a>&nbsp;{{'dataExtractionOverviewPage.p3_2'|cxTranslate}}
            </p>

            <div class="data-extraction__disclaimer">
                <label class="checkbox">
                    <input type="checkbox" formControlName="valueDisclaimer">
                    <span>{{'dataExtractionOverviewPage.p4_1'|cxTranslate}}&nbsp;<u><a
                                (click)="openBendixDataExtractionDisclaimer()">{{'dataExtractionOverviewPage.p4_2'|cxTranslate}}</a></u>&nbsp;</span>
                </label>
            </div>

            <button class="btn-next mt-4" id="nextBtn" (click)="nextPage()"
                [disabled]="!allowNext">{{'dataExtractionRquest.Next'|cxTranslate}}
                <img src="/icons/link-white.svg" class="next-icon-right default-icon" alt="">
            </button>
        </form>
    </div>
</div>